import { FC } from "react";
import { Button, DialogActions } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useAppSelector } from "@/store/hooks";
import { sendSingleReportLoadingSelector } from "@/store/reports/selector/sendSingleReportLoadingSelector";
import { sendSingleReportButtonDisabledSelector } from "@/store/reports/selector/sendSingleReportButtonDisabledSelector";
import { OneTimeReportType } from "@/components/pages/common/send-report/utils/types/types";

interface SendReportDialogActionsProps {
  onClose(): void;
  onSend(): void;
  type: OneTimeReportType;
}

export const SendReportDialogActions: FC<SendReportDialogActionsProps> = ({
  onClose,
  onSend,
  type,
}) => {
  const loading = useAppSelector(sendSingleReportLoadingSelector);
  const disabled = useAppSelector((state) =>
    sendSingleReportButtonDisabledSelector(state, type),
  );

  return (
    <DialogActions sx={{ overflow: "hidden" }}>
      <Button disabled={loading} onClick={onClose} color="tertiary">
        Cancel
      </Button>
      <LoadingButton
        variant="contained"
        color="primary"
        onClick={onSend}
        loading={loading}
        disabled={disabled}
        sx={{ m: 1 }}
      >
        Send
      </LoadingButton>
    </DialogActions>
  );
};
